import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { STATUS, money } from "@/lib/api";

export default function PondMap({ projects, height = 480 }) {
  return (
    <div className="rounded-3xl overflow-hidden border border-sky-100 shadow-sm" style={{ height }} data-testid="pond-map">
      <MapContainer center={[30.3322, -81.6557]} zoom={10} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {projects.map((p) => (
          <CircleMarker key={p.code} center={[p.lat, p.lng]} radius={11} pathOptions={{ color: "#fff", weight: 3, fillColor: STATUS[p.status]?.color, fillOpacity: 1 }}>
            <Popup>
              <div className="min-w-[180px]">
                <p className="font-bold text-[#03045E]">{p.code}</p>
                <p className="text-sm">{p.name}</p>
                <p className="text-xs mt-1" style={{ color: STATUS[p.status]?.color }}>{STATUS[p.status]?.label} — {STATUS[p.status]?.note}</p>
                {p.goal_total > 0 && <p className="text-xs mt-1">{money(p.raised_total)} of {money(p.goal_total)}</p>}
                <Link to={`/projects/${p.code}`} className="text-sm font-bold text-[#0077B6]" data-testid={`map-open-${p.code}`}>Open project →</Link>
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}

export const MapLegend = () => (
  <div className="flex flex-wrap gap-3" data-testid="map-legend">
    {Object.entries(STATUS).map(([k, s]) => (
      <span key={k} className="flex items-center gap-2 text-xs font-bold uppercase text-[#03045E]"><span className="w-3 h-3 rounded-full" style={{ background: s.color }} /> {s.label}</span>
    ))}
  </div>
);
